"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetsResponseToJSON = exports.AdSetsResponseFromJSONTyped = exports.AdSetsResponseFromJSON = exports.instanceOfAdSetsResponse = void 0;
var runtime_1 = require("../runtime");
var AdSetResponse_1 = require("./AdSetResponse");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the AdSetsResponse interface.
 */
function instanceOfAdSetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdSetsResponse = instanceOfAdSetsResponse;
function AdSetsResponseFromJSON(json) {
    return AdSetsResponseFromJSONTyped(json, false);
}
exports.AdSetsResponseFromJSON = AdSetsResponseFromJSON;
function AdSetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'adSets': !(0, runtime_1.exists)(json, 'ad_sets') ? undefined : (json['ad_sets'].map(AdSetResponse_1.AdSetResponseFromJSON)),
    };
}
exports.AdSetsResponseFromJSONTyped = AdSetsResponseFromJSONTyped;
function AdSetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'ad_sets': value.adSets === undefined ? undefined : (value.adSets.map(AdSetResponse_1.AdSetResponseToJSON)),
    };
}
exports.AdSetsResponseToJSON = AdSetsResponseToJSON;
